module.exports = __webpack_public_path__ + "img/4.71f577a0.jpg";